import { Link,   useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { useRef, useLayoutEffect } from "react";

import gsap from "gsap";

// Logo
import Logo from "../logo.png"

export default function Navbar() {
  const [isServicesOpen, setIsServicesOpen] = useState(false);
  const [open, setOpen] = useState(false);

  const handleClick = () => {
    if (!open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
    setOpen(!open);
  };

  const navRef = useRef();



  useEffect(() => {
  if (isServicesOpen) {
    gsap.fromTo(
      ".dropdown-wrappers",
      { y: -10, opacity: 0 },
      { y: 0, opacity: 1, duration: 0.3 }
    );
  }
}, [isServicesOpen]);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      // navbar reveal animation
      gsap.from(navRef.current, {
        yPercent: -100,
        opacity: 0,
        duration: 1,
        ease: "power4.out"
      });
    }, navRef);

    return () => ctx.revert();
  }, []);

  return (
    <>
      <div ref={navRef} className="nav-bar is-black">

      {/* Logo */}
      <Link to="/" className="logo-wrapper">
        <div className="link-wrap is-logo">
          <div className="logo"><img src={Logo} alt="Pthurp"/></div>
        </div>
      </Link>

      {/* Center Line */}
      <div className="nav-line-wrapper">
        <div className="navbar-line" />
      </div>

      {/* Menu */}
      <div className="nav-menu">

        <NavItem to="/about" label="About Us" />
       <div
  className="nav-item-wrappers"
  onMouseEnter={() => setIsServicesOpen(true)}
  onMouseLeave={() => setIsServicesOpen(false)}
>
  <NavItem to="/services" label="Our Services" />

  {/* Dropdown INSIDE this */}
  <div
    className="dropdown-wrappers"
    style={{
      opacity: isServicesOpen ? 1 : 0,
      visibility: isServicesOpen ? "visible" : "hidden",
      transform: isServicesOpen
        ? "translateY(0px)"
        : "translateY(-10px)",
      transition: "all 0.3s ease"
    }}
  >
    <div className="dropdown-inners">
      
      <Link className="m-menu-link" to="/services?tab=design">Design</Link>
      <Link className="m-menu-link" to="/services?tab=infrastructure">Infrastructure</Link>
      <Link className="m-menu-link" to="/services?tab=maintenance">Maintenance</Link>
      <Link className="m-menu-link" to="/services?tab=improvements">Improvements</Link>
    </div>
  </div>
</div>
        <NavItem to="/partners" label="Partners" />
        <NavItem to="/contact" label="Contact Us" />

        {/* Burger */}
        <div className="burger-menu is-black" onClick={handleClick}>
          <div className="burger-line-wrapper">
            <div className="burger-line is-1" />
            <div className="burger-line is-2" />
          </div>
        </div>
      </div>
    </div>
    

      {/* Dropdown */}
      <div
        className="dropdown-wrapper"
        style={{
          display: open ? "flex" : "none",
          transform: open
            ? "translate3d(0%, 0px, 0px) scale3d(1,1,1)"
            : "translate3d(0%, -20px, 0px) scale3d(0.95,0.95,1)",
          transformStyle: "preserve-3d",
          transition: "all 0.4s ease"
        }}
      >
        <div className="dropdown-inner">
          <a href="/about" class="m-menu-link w-inline-block">
            <div class="m-menu-no-wrap">
                <div class="m-menu-no">01</div>
            </div>
            <div class="m-link-text-con">
                <div class="m-link-text-wrap">
                    <div class="m-menu-link-txt">About</div>
                </div>
                <div class="m-link-text-wrap">
                    <div class="m-menu-link-txt">us</div>
                </div>
            </div>
         </a>


         <a href="/services" class="m-menu-link w-inline-block">
            <div class="m-menu-no-wrap">
                <div class="m-menu-no">02</div>
            </div>
            <div class="m-link-text-con">
                <div class="m-link-text-wrap">
                    <div class="m-menu-link-txt">Our</div>
                </div>
                <div class="m-link-text-wrap">
                    <div class="m-menu-link-txt">Services</div>
                </div>
            </div>
         </a>


          <a href="/partners" class="m-menu-link w-inline-block">
            <div class="m-menu-no-wrap">
                <div class="m-menu-no">03</div>
            </div>
            <div class="m-link-text-con">
                <div class="m-link-text-wrap">
                    <div class="m-menu-link-txt">Our</div>
                </div>
                <div class="m-link-text-wrap">
                    <div class="m-menu-link-txt">Partners</div>
                </div>
            </div>
         </a>


         <a href="/contact" class="m-menu-link w-inline-block">
            <div class="m-menu-no-wrap">
                <div class="m-menu-no">04</div>
            </div>
            <div class="m-link-text-con">
                <div class="m-link-text-wrap">
                    <div class="m-menu-link-txt">Get to</div>
                </div>
                <div class="m-link-text-wrap">
                    <div class="m-menu-link-txt">Know us</div>
                </div>
            </div>
         </a>



        </div>

        {/* CLOSE BUTTON */}
        <div class="close-menu" onClick={() => setOpen(false)}>
            <div class="burger-line-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
  <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
</svg>
                {/* <div class="burger-line is-c-1"></div>
                <div class="burger-line is-c-2"></div> */}
            </div>
        </div>
      </div>
    </>
  );
}

function NavItem({ to, label }) {
  const line1 = useRef(null);
  const line2 = useRef(null);
  const location = useLocation();

  const isActive = location.pathname === to;

  const hoverIn = () => {
    gsap.to(line1.current, {
      width: "100%",
      duration: 0.4,
      ease: "power2.out",
    });

    gsap.to(line2.current, {
      width: "100%",
      duration: 0.4,
      delay: 0.1,
      ease: "power2.out",
    });
  };

  const hoverOut = () => {
    gsap.to([line1.current, line2.current], {
      width: "0%",
      duration: 0.4,
      ease: "power2.in",
    });
  };

  return (
    <div
      className="link-wrap is-nav"
      onMouseEnter={hoverIn}
      onMouseLeave={hoverOut}
    >
      <a to={to} href={to} className={`link is-nav ${isActive ? "active" : ""}`}>
        {label}
      </a>

      <div ref={line1} className={`nav-line is-1 ${isActive ? "active" : ""}`} />
      <div ref={line2} className={`nav-line is-2 ${isActive ? "active" : ""}`} />
    </div>
  );
}